var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 8,
    viewBox: "0 0 16 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 0H4.66666C2.45999 0 0.666656 1.79333 0.666656 4C0.666656 6.20667 2.45999 8 4.66666 8H11.3333C13.54 8 15.3333 6.20667 15.3333 4C15.3333 1.79333 13.54 0 11.3333 0ZM11.3333 6.66667H4.66666C3.19332 6.66667 1.99999 5.47333 1.99999 4C1.99999 2.52667 3.19332 1.33333 4.66666 1.33333H11.3333C12.8067 1.33333 14 2.52667 14 4C14 5.47333 12.8067 6.66667 11.3333 6.66667ZM4.66666 2C3.55999 2 2.66666 2.89333 2.66666 4C2.66666 5.10667 3.55999 6 4.66666 6C5.77332 6 6.66666 5.10667 6.66666 4C6.66666 2.89333 5.77332 2 4.66666 2Z",
    fill: "#C1C7CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactive);
export default __webpack_public_path__ + "static/media/inactive.cec55cdfc2929d26238daefe928d751c.svg";
export { ForwardRef as ReactComponent };